import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import KastPage from "./components/KastPage";
import "./print.css";
import "./index.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/kast/:size" element={<KastPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
